import { developAxios } from "../../axios.config";

export function updateLearningData(selectedCourse, learningData) {
	developAxios(localStorage.getItem("token"))
		.post(`/update-learning-data/${selectedCourse}`, {
			learning: learningData,
		})
		.then(({ data }) => {
			return true;
		})
		.catch((e) => {
			return false;
		});
}
